import { render } from "./Documents.vue?vue&type=template&id=0dc0f7d3&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"

import "./Documents.vue?vue&type=style&index=0&id=0dc0f7d3&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\HanYaqoob\\Desktop\\REPOS\\DebtCrmPortalUI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc0f7d3"]])

export default __exports__